import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import {
  BoldSpan,
  ButtonsContainer,
  DialogWrapper,
  Divider,
  ModalContainer,
  ModalContent,
  ModalLabel,
  ModalRow,
  ModalTitle,
  ModalValue,
} from './styles';
import { AlertModalProps } from './types';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import ActionButton from '../../../components/ActionButton/ActionButton';

export const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  businessPartnerName,
}) => {
  const { t } = useI18n();
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };
  return (
    <DialogWrapper open={isOpen} onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', top: 16, right: 16 }}
        >
          <CloseIcon />
        </IconButton>
        <ModalTitle>{t(TranslationKeys.eshop_modal_title)}</ModalTitle>
        <ModalContent>
          <ModalRow>
            <ModalLabel>
              {t(TranslationKeys.eshop_modal_business_partner)}
            </ModalLabel>
            <ModalValue>{businessPartnerName}</ModalValue>
          </ModalRow>
          <Divider />
          <ModalRow>
            <ModalLabel>
              {t(TranslationKeys.eshop_modal_content_prefix)}{' '}
              <BoldSpan>{businessPartnerName}</BoldSpan>
              {t(TranslationKeys.eshop_modal_content_suffix)}
            </ModalLabel>
          </ModalRow>
        </ModalContent>
        <ButtonsContainer>
          <ActionButton
            variant="cancel"
            buttonText={t(TranslationKeys.common_cancel)}
            onClickAction={onClose}
          />
          <ActionButton
            variant="accept-blue"
            buttonText={t(TranslationKeys.common_confirm)}
            onClickAction={handleConfirm}
          />
        </ButtonsContainer>
      </ModalContainer>
    </DialogWrapper>
  );
};
